import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const BackgroundColor = 'bg.muted'
const TextColor = 'fg.default'
const EnvironmentLabelStyleParts = ['container', 'text'] as const
const helpers = createMultiStyleConfigHelpers(EnvironmentLabelStyleParts)
export const EnvironmentLabelStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: BackgroundColor,
      borderRadius: '6px',
      padding: '8px',
      userSelect: 'none',
    },
    text: {
      color: TextColor,
      ...textStyles[textStyleKeys.Body3],
    },
  },
})
export const useEnvironmentLabelStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(EnvironmentLabelStyle, props) as MultiStyleType<
    typeof EnvironmentLabelStyleParts
  >
}
